<template>
  <div class="form-container ou-donation-form rtl" dir="rtl">
    <div class="holder">
      <PaymentForm class="form-horizontal">
        <FormSection title="רכישת המשחק">
          <FormRow inline>
            <AmountSelectorGames />
          </FormRow>
        </FormSection>
        <FormSection title="פרטים אישיים">
          <FormRow inline>
            <div class="custom__id">
              <FormLabel class="control-label forceShow" lang="he">
                חשבונית מס
                <span class="custom__id__sub">(שם הארגון ומספר ח.פ.)</span>
              </FormLabel>
              <FormInput
                type="text"
                class="width-full"
                field="custom.chesbonitmas"
                lang="he"
              />
            </div>
          </FormRow>
          <FormRow inline class="israeli-tax-id-row">
            <FormCol field="taxId" label="תעודת זהות" placeholder="הזן תעודת זהות" />
          </FormRow>
          <FormRow inline>
            <FormCol field="firstName" :flex="2" />
            <FormCol field="lastName" :flex="2" />
          </FormRow>
          <FormRow inline>
            <FormCol field="email" />
            <FormCol field="phone" />
          </FormRow>
          <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/" lang="heb"/>
                  </FormRow>  
        </FormSection>
        <FormSection title="כתובת" last>
          <div class="hebrew__adreess">
            <FormRow inline>
              <FormCol field="street" :flex="2" />
              <FormCol field="custom.houseNumber" :flex="1" class="forceShow" />
            </FormRow>
            <FormRow inline>
              <FormCol field="city" :flex="2" />
              <FormCol field="zip" :flex="1" />
            </FormRow>
          </div>
        </FormSection>
        <FormSection title="">
          <FormRow>
            <FormLabel class="control-label forceShow"> הערות </FormLabel>
          </FormRow>
          <FormRow>
            <FormInput type="textarea" class="width-half" field="custom.Notes" />
          </FormRow>
        </FormSection>
        <FormSection title="" last>
          <FormRow>
            <input
              type="checkbox"
              id="newAddress"
              name="newAddress"
              :checked="newAddress" @click="newAddress = $event.target.checked"
            />
            <FormLabel for="newAddress" class="forceShow newaddress"
              >שלח לכתובת אחרת</FormLabel
            >
          </FormRow>
        </FormSection>
        <FormSection title="כתובת למשלוח" last v-if="newAddress">
          <div class="second__address">
            <SecondAddress lang="he" />
          </div>
        </FormSection>

        <FormRow inline>
          <FormCol field="card" :showLabel="false" lang="he" />
        </FormRow>
        <PaymentButton showAmount btnText="לשׁלם" />
      </PaymentForm>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, watch, ref, onMounted } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup(props) {
    const { setValue, form, getValue, submit } = usePaymentForm();

    const newAddress = ref(false);

    watch(newAddress, () => setValue("custom.customCountry", "IL"));

    onMounted(() => {
      setValue("currency", "ILS");
      setValue('gateway', 'SensepassCardcomPayments');
      setValue("country", "IL");
    });

    return {
      form,
      newAddress,
      setValue,
      getValue,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}

.newaddress {
  padding: 0px 6px;
}
.custom__id {
  max-width: 50%;
}
.custom__id__sub {
  display: block;
  font-size: 13px;
  line-height: normal;
}

::v-deep .ou-donation-btn {
  background: #fbad18;
  border: 1px solid #fbad18;
  color: black;
  svg g {
    fill: black;
  }
}

::v-deep .hebrew__adreess label[for="custom.houseNumber"]:after {
  content: "מספר בית";
}
::v-deep .hebrew__adreess label[for="street"]:after {
  content: "רחוב" !important;
}
</style>
